import script from "./MediaInfoHero.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaInfoHero.vue?vue&type=script&setup=true&lang=js"

import "./MediaInfoHero.vue?vue&type=style&index=0&id=26ee10aa&lang=less"

const __exports__ = script;

export default __exports__